import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";

const getCookie = (name) => {
    // const cookieName = `${name}=`;
    // const cookies = document.cookie.split(';');
    // for (let i = 0; i < cookies.length; i++) {
    //   let cookie = cookies[i];
    //   while (cookie.charAt(0) === ' ') {
    //     cookie = cookie.substring(1);
    //   }
    //   if (cookie.indexOf(cookieName) === 0) {
    //     console.log(cookie.substring(cookieName.length, cookie.length,"cookieValues"))
    //     return cookie.substring(cookieName.length, cookie.length);
    //   }
    // }
    const journeyId = sessionStorage.getItem(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
    if(journeyId){
      return journeyId
    }
    return null;
  }

export default getCookie  